import { render } from "./WatchTriPane.vue?vue&type=template&id=d48cf322&scoped=true"
import script from "./WatchTriPane.vue?vue&type=script&lang=js"
export * from "./WatchTriPane.vue?vue&type=script&lang=js"

import "./WatchTriPane.vue?vue&type=style&index=0&id=d48cf322&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d48cf322"]])

export default __exports__